<template>
  <el-dialog
    :visible.sync="DialogShow"
    @closed="closeDialog"
    @open="openDialog"
    append-to-body
  >
    <div slot="title" class="dialog-title">
      <span class="title-line"></span>
      <span class="title-text">{{ title }}</span>
    </div>
    <el-form
      :model="submitFormData"
      :rules="rules"
      ref="form"
      label-width="160px"
      class="demo-submitFormData"
      style="padding: 20px 0 10px 60px"
    >
      <el-form-item label="时间范围" prop="datePicker">
        <el-date-picker
          class="long-inp"
          v-model="submitFormData.datePicker"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          @blur="chooseDateOver"
        >
        </el-date-picker>
      </el-form-item>
    </el-form>
    <div class="from-btn-wrap">
      <el-button type="primary" @click="handelClickSubmit" size="small">{{
        upDataMsg
      }}</el-button>
      <el-button type="primary" plain size="small" @click="handelClickCancel"
        >取消</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { countryCalendarCreate } from '@/api/country';
import { clone } from '@/utils/utils';
const defaultUpdataObj = {
  end: '',
  start: '',
  countryBid: '',
  reason: '',
  datePicker: [],
};
export default {
  data() {
    return {
      DialogShow: false,
      upDataMsg: '保存',
      submitFormData: clone(defaultUpdataObj),
      rules: {
        datePicker: [
          { required: true, message: '请选择时间范围', trigger: 'change' },
        ],
      },
    };
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    rowDetail: {
      type: Object,
      default: {},
    },
  },
  methods: {
    openDialog() {
      this.submitFormData.countryBid = this.rowDetail.countryBid;
      this.$nextTick(() => {
        this.$refs.form.resetFields();
      });
    },
    closeDialog() {
      this.DialogShow = false;
      this.submitFormData = clone(defaultUpdataObj);
    },
    handelClickCancel() {
      this.closeDialog();
    },
    chooseDateOver() {
      this.submitFormData.start = this.submitFormData.datePicker[0];
      this.submitFormData.end = this.submitFormData.datePicker[1];
    },
    handelClickSubmit() {
      if (this.upDataMsg == '保存') {
        this.$refs.form.validate((valid) => {
          if (!valid) {
            return false;
          } else {
            this.upDataMsg = '保存中..';
            delete this.submitFormData.datePicker;
            countryCalendarCreate(this.submitFormData).then((res) => {
              if (res.code == 200) {
                this.$msg.success('保存成功！');
                this.$emit('upData');
                this.closeDialog();
              }
              this.upDataMsg = '保存';
            });
          }
        });
      }
    },
  },
};
</script>

<style>
</style>